// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"75":"8a2717ed","139":"0defac6d","453":"68693753","676":"d0fc388a","961":"4bcc1f2b"}[chunkId] + ".chunk.js";
};